/** i18n key for a stored belt value (e.g. "Blue", "GreyWhite" → "blue_belt", "grey_white_belt"). */
export const beltToTranslationKey = (belt) => {
  if (!belt || typeof belt !== "string") return null;
  const snake = belt
    .trim()
    .replace(/([a-z])([A-Z])/g, "$1_$2")
    .replace(/[-\s]+/g, "_")
    .toLowerCase();
  return `${snake}_belt`;
};

/** Localized belt label; falls back to spaced title case if no translation exists. */
export const getBeltDisplayName = (belt, t) => {
  if (!belt || typeof belt !== "string") return "";
  const key = beltToTranslationKey(belt);
  if (key && typeof t === "function") {
    const translated = t(key);
    if (translated && translated !== key) return translated;
  }
  return belt
    .replace(/([A-Z])/g, " $1")
    .trim()
    .split(" ")
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");
};

export const getBeltImage = (belt, beltSystemKey = "bjj") => {
  if (!belt || typeof belt !== "string") return null;
  if (beltSystemKey && beltSystemKey !== "bjj") return null;

  // Normalize belt name: lowercase, remove dashes and spaces
  const normalizedBelt = belt.toLowerCase().replace(/[-\s]/g, "");

  const beltImages = {
    white: '/belts_adult/belt-white.png',
    blue: '/belts_adult/belt-blue.png',
    purple: '/belts_adult/belt-purple.png',
    brown: '/belts_adult/belt-brown.png',
    black: '/belts_adult/belt-black.png',
    coral: '/belts_adult/belt-black.png',
    greywhite: '/belts_kids/belt-grey-white.png',
    grey: '/belts_kids/belt-grey.png',
    greyblack: '/belts_kids/belt-grey-black.png',
    yellowwhite: '/belts_kids/belt-yellow-white.png',
    yellow: '/belts_kids/belt-yellow.png',
    yellowblack: '/belts_kids/belt-yellow-black.png',
    orangewhite: '/belts_kids/belt-orange-white.png',
    orange: '/belts_kids/belt-orange.png',
    orangeblack: '/belts_kids/belt-orange-black.png',
    greenwhite: '/belts_kids/belt-green-white.png',
    green: '/belts_kids/belt-green.png',
    greenblack: '/belts_kids/belt-green-black.png',
  };

  return beltImages[normalizedBelt] || null;
};

/**
 * UI accent colors sampled from belt PNG assets (center fabric tone).
 * Two-tone belts use the saturated stripe color, not white/black segments.
 */
const BELT_ACCENT_COLORS = {
  white: "#F5F5F5",
  blue: "#2969AE",
  purple: "#6C3C90",
  brown: "#4F3319",
  black: "#1A1A1A",
  coral: "#E31E24",
  grey: "#7E8284",
  greywhite: "#7E8284",
  greyblack: "#7E8284",
  yellow: "#FAC840",
  yellowwhite: "#FAC840",
  yellowblack: "#FAC840",
  orange: "#F15E3A",
  orangewhite: "#F15E3A",
  orangeblack: "#F15E3A",
  green: "#105D36",
  greenwhite: "#105D36",
  greenblack: "#105D36",
};

/** Accent color for UI styling (borders, dividers) from belt name. */
export const getBeltAccentColor = (belt) => {
  if (!belt || typeof belt !== "string") return null;

  const normalizedBelt = belt.toLowerCase().replace(/[-\s]/g, "");
  return BELT_ACCENT_COLORS[normalizedBelt] || null;
};

  
  export const getStripeImage = (stripeCount, beltSystemKey = "bjj") => {
    if (beltSystemKey && beltSystemKey !== "bjj") return null;
    const stripeImages = {
      0: '/belts_adult/stripe-0.png',
      1: '/belts_adult/stripe-1.png',
      2: '/belts_adult/stripe-2.png',
      3: '/belts_adult/stripe-3.png',
      4: '/belts_adult/stripe-4.png',
      "yellow": '/belts_kids/promotion_yellow_small.png',
      "orange": '/belts_kids/promotion_orange_small.png',
      "green": '/belts_kids/promotion_green_small.png',
      "blue": '/belts_kids/promotion_blue_small.png',
    };
    return stripeImages[stripeCount] || null;
  };